<nav class="navbar h-100 flex-md-nowrap p-0 z-shadow mt-0">
    <div class="container-fluid">
        <div class="d-flex flex-row w-100 m-0">
            <div class="d-flex align-items-center sidebar-button mr-4">
                <button class="btn">
                    <i class="fas fa-bars" (click)="toggleSidebar()"></i>
                </button>
            </div>
            <div class="d-flex align-items-center header-buttons">
                <div class="d-flex flex-row">
                    <div *ngFor="let button of headerButtons" class="d-flex align-items-start px-0 mr-3">
                        <button
                            class="btn px-3 py-1 my-2 w-100 rounded"
                            [ngStyle]="{ 'background-color': button.color, border: '1px solid' + button.borderColor }"
                            (click)="button.callback($event)"
                        >
                            <i
                                [ngStyle]="{ color: button.fontColor }"
                                class="fa {{ button.icon }}"
                                placement="bottom"
                                ngbTooltip="{{ button.label | translate }}"
                            ></i>
                            <span [ngStyle]="{ color: button.fontColor }">{{ button.label | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center ml-auto">
                <div class="d-inline-block dropdown rounded" ngbDropdown #myDrop="ngbDropdown">
                    <button class="btn py-0" id="dropdownManual" ngbDropdownAnchor (focus)="myDrop.open()">
                        <i class="fas fa-user"></i>
                        <span class="pr-2">{{ loggedUserEmail }}</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownManual" class="dropdown-menu-right">
                        <button (click)="onProfileClick()" ngbDropdownItem>{{
                            "PROFILE_COMPONENT_MY_PROFILE_BUTTON" | translate
                        }}</button>
                        <button (click)="logout()" ngbDropdownItem>{{ "HEADER_COMPONENT_LABEL_LOGOUT" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>
